import React from 'react';
import { CalendarDayProps } from './types';
export const CalendarDay: React.FC<CalendarDayProps> = ({
  date,
  isSelected,
  isToday,
  isCurrentMonth,
  isDisabled,
  onClick,
  onKeyDown
}) => {
  const handleClick = () => {
    if (!isDisabled && isCurrentMonth) {
      onClick(date);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!isDisabled && isCurrentMonth) {
      onKeyDown(e, date);
    }
  };
  const baseClasses = 'flex items-center justify-center w-12 h-12 rounded-md text-[14px] font-normal transition-all duration-200';
  let classes = baseClasses;
  if (!isCurrentMonth) {
    classes += ' text-transparent pointer-events-none';
  } else if (isDisabled) {
    classes += ' text-[#94A3B8] opacity-50 cursor-not-allowed';
  } else if (isSelected) {
    classes += ' bg-[#0EA5E9] text-white font-medium shadow-sm';
  } else if (isToday) {
    classes += ' text-[#0F172A] font-medium ring-2 ring-[#0EA5E9] ring-inset';
  } else {
    classes += ' text-[#0F172A] hover:bg-[#F8FAFC] cursor-pointer';
  }
  const ariaLabel = isCurrentMonth ? `Select ${date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  })}` : '';
  return <button type="button" role="gridcell" aria-label={ariaLabel} aria-selected={isSelected} aria-disabled={isDisabled} tabIndex={isSelected ? 0 : -1} className={classes} onClick={handleClick} onKeyDown={handleKeyDown} disabled={isDisabled || !isCurrentMonth} data-id="element-465">
      {isCurrentMonth ? date.getDate() : ''}
    </button>;
};